import AsyncControl from '@/Controls/AsyncControl';
import ComponentManager from '@/Management/ComponentManager';
import AutoTwoColumnLayoutViewModelType from '@/ViewModels/Controls/AutoTwoColumnLayoutViewModel';
import ColumnLayoutType from '@/Controls/ColumnLayout';

export default class AutoTwoColumnLayout extends AsyncControl {

    private ColumnLayout = ComponentManager.getControl<typeof ColumnLayoutType>('ColumnLayout');
    private jQueryControl: JQuery;
    private columnLayoutLeft: ColumnLayoutType;
    private columnLayoutRight: ColumnLayoutType;

    public constructor(private viewModel: AutoTwoColumnLayoutViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public async getElementAsync(): Promise<JQuery> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyBindings(this.jQueryControl, {
            controlName: 'autotwocolumnlayout',

            controlIdent: this.identifier,

            loader: this.viewModel.isBusy
        });

        await this.viewModel.executeBusilyAsync(async () => {
            if (this.viewModel.columnLayoutLeft != null) {
                const $leftControl = await this.createItemAsync(null, () => {
                    this.columnLayoutLeft = new this.ColumnLayout(this.viewModel.columnLayoutLeft);
                    const tuple = this.columnLayoutLeft.getTuple();
                    return tuple.control;
                });
                $leftControl?.appendTo(this.jQueryControl);
            }

            if (this.viewModel.columnLayoutRight != null) {
                const $rightControl = await this.createItemAsync(null, () => {
                    this.columnLayoutLeft = new this.ColumnLayout(this.viewModel.columnLayoutRight);
                    const tuple = this.columnLayoutRight.getTuple();
                    return tuple.control;
                });
                $rightControl?.appendTo(this.jQueryControl);
            }

            $('<div class="clear">').appendTo(this.jQueryControl);
            this.widget(null);
        });

        return this.jQueryControl;
    }
}

ComponentManager.setControl('AutoTwoColumnLayout', AutoTwoColumnLayout, 'RADPresentation.HTMLClient.DefaultViewExtensions');